<div class="tickets">
  <div class="mt-2 mb-5 btns-section">
    <span
      class="text-muted"
      *ngIf="selectedInvoiceTickets?.length > 0"
      style="align-content: center; font-size: medium; margin: 0 5px"
      >{{ selectedInvoiceTickets?.length }}
      {{ "Sport.SelectedTickets" | translate }}</span
    >
    <button
      *ngIf="selectedInvoiceTickets?.length > 0"
      class="transfer-all-btn basic-btn"
      (click)="transferTickets()"
      [disabled]="preventTransferAll"
    >
      <span
        style="padding-inline-start: 2%"
        [style.color]="preventTransferAll ? '#808080' : ''"
      >
        {{ "Sport.TransferAllTickets" | translate }}</span
      >
    </button>
    <button
      *ngIf="selectedInvoiceTickets?.length > 0"
      class="transfer-all-btn basic-btn"
      (click)="cancelTransferTickets()"
      [disabled]="preventCancelAll"
    >
      <span
        style="padding-inline-start: 2%"
        [style.color]="preventCancelAll ? '#808080' : ''"
      >
        {{ "Sport.CancelAllTickets" | translate }}</span
      >
    </button>
  </div>
  <div *ngIf="invoices; else loader">
    <div *ngIf="invoices.length; else noData">
      <div *ngFor="let ticket of invoices">
        <div class="ticket-row my-tickets">
          <input
            class="form-check-input"
            [ngClass]="{
              'extra-margin-top': ticket.transferOrderStatus === 'UNDERTRANSFER'
            }"
            type="checkbox"
            [style.background-color]="ticket.isChecked ? '#3dbeb4' : ''"
            [style.border-color]="ticket.isChecked ? '#3dbeb4' : ''"
            (change)="toggleCheckbox(ticket)"
            [checked]="ticket.isChecked"
          />
          <div
            class="ticket-card"
            [style.border]="ticket.isChecked ? '1px solid #3dbeb4' : ''"
          >
            <div
              *ngIf="ticket.transferOrderStatus === 'UNDERTRANSFER'"
              class="ticket-card__pending-label"
            >
              {{ "pending" | translate }}
            </div>
            <div class="row disk-top-display">
              <div class="ticket-card__item col-md-5">
                <div class="match-data borderd">
                  <div class="match-card">
                    <div>
                      <img src="{{ ticket.teamHomeLogo }}" />
                      <div class="mt-2">
                        <div *ngIf="translate.currentLang === 'ar'">
                          {{ ticket.teamHomeNameAr }}
                        </div>
                        <div *ngIf="translate.currentLang === 'en'">
                          {{ ticket.teamHomeNameEn }}
                        </div>
                      </div>
                    </div>

                    <span class="black-box">
                      {{ ticket.matchDate | date }} |
                      {{ ticket.matchTime }}
                    </span>
                    <div>
                      <img src="{{ ticket.teamAwayLogo }}" />
                      <div class="mt-2">
                        <div *ngIf="translate.currentLang === 'ar'">
                          {{ ticket.teamAwayNameAr }}
                        </div>
                        <div *ngIf="translate.currentLang === 'en'">
                          {{ ticket.teamAwayNameEn }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="ticket-card__item col-md-3">
                <div class="borderd">
                  <div class="ticket-card__item__ticket-type">
                    {{
                      translate.currentLang === "ar"
                        ? ticket.ticketNameAr
                        : ticket.ticketNameEn
                    }}
                  </div>

                  <div class="ticket-card__item__sub-content">
                    <span *ngIf="ticket.seat">
                      {{ "Tickets.Section" | translate }}
                      {{ ticket.section }},
                      {{ "Tickets.Row" | translate }}
                      {{ ticket.row }},
                      {{ "Tickets.Seat" | translate }}
                      {{ ticket.seat }}
                    </span>
                    <span *ngIf="!ticket.seat">
                      {{ "Tickets.ChooseYourAppropriateSeat" | translate }}
                    </span>
                  </div>
                </div>
              </div> -->
              <div class="ticket-card__item col-sm-5 col-md-3">
                <div class="ticket-card__item__ticket-price">
                  <span
                    class="ticket-card__item__ticket-price-large-title"
                    *ngIf="
                      ticket.transferOrderStatus !== 'TRANSFERRED' &&
                      ticket.transferOrderStatus !== 'UNDERTRANSFER'
                    "
                  >
                    <ng-container *ngIf="ticket.price !== 0">
                      <span
                        [innerHTML]="
                          ticket.price * 1.15
                            | number : '1.2-2'
                            | customCurrency : 'SAR' : 'symbol' : '#2f78ee' : 33
                        "
                      ></span>
                    </ng-container>

                    <ng-container *ngIf="ticket.price === 0">
                      {{ "free" | translate }}
                    </ng-container>
                  </span>
                  <span
                    class="ticket-card__item__ticket-price-medium-title"
                    *ngIf="ticket.transferOrderStatus === 'TRANSFERRED'"
                  >
                    {{ "Sport.TransferredToMe" | translate }}
                  </span>
                  <span
                    class="ticket-card__item__ticket-price-small-title"
                    *ngIf="ticket.transferOrderStatus === 'UNDERTRANSFER'"
                  >
                    {{ "Sport.TransferredTo" | translate }}
                  </span>
                </div>

                <div
                  class="ticket-card__item__sub-content"
                  *ngIf="
                    ticket.transferOrderStatus !== 'TRANSFERRED' &&
                    ticket.transferOrderStatus !== 'UNDERTRANSFER'
                  "
                >
                  {{ ticket.price }} / {{ "Sport.Ticket" | translate }} +
                  {{ (ticket.price * 1.15 - ticket.price).toFixed(2) }}
                  {{ "Sport.tax" | translate }}
                </div>

                <div
                  *ngIf="ticket.transferOrderStatus === 'UNDERTRANSFER'"
                  class="ticket-card__item__receiver-sub-content"
                >
                  <div>
                    {{
                      ticket.receiverFirstName + " " + ticket.receiverLastName
                    }}
                  </div>
                  <div class="mt-1">
                    <span *ngIf="translate.currentLang === 'en'">
                      {{ ticket.receiverMobile }}
                    </span>
                    <span *ngIf="translate.currentLang === 'ar'">
                      {{ helpers.returnMobileArabic(ticket.receiverMobile) }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="ticket-card__item col-sm-5 col-md-3">
                <button
                  *ngIf="ticket.transferOrderStatus !== 'UNDERTRANSFER'"
                  app-click-stop-propagation
                  class="ticket-card__item__btn basic-btn mb-2"
                  (click)="
                    ticket.id === '$$$$'
                      ? transferDisabledTicket(ticket.ticketNumber)
                      : transferTicket(ticket.id)
                  "
                  [disabled]="ticket.ticketSubKind === 'FULL_SEASON'"
                >
                  <div style="text-align: -webkit-center; display: flex">
                    <img
                      src="/assets/images/icons/share.svg"
                      [style.opacity]="
                        ticket.ticketSubKind === 'FULL_SEASON' ? '0.5' : ''
                      "
                    />
                    <span class="fw-bold">
                      {{ "Sport.Transfer" | translate }}</span
                    >
                  </div>
                </button>

                <button
                  app-click-stop-propagation
                  *ngIf="ticket.transferOrderStatus === 'UNDERTRANSFER'"
                  class="ticket-card__item__btn basic-btn mb-2"
                  (click)="cancelTicket([ticket.transferOrderId])"
                >
                  <div>
                    <span class="fw-bold">
                      {{ "Sport.CancelTransfer" | translate }}</span
                    >
                  </div>
                </button>

                <button
                  class="ticket-card__item__btn basic-btn"
                  (click)="toggleExpand(ticket)"
                >
                  <div style="text-align: -webkit-center; display: flex">
                    <img
                      [src]="
                        ticket.expanded
                          ? 'assets/images/icons/arrow-up_dark.svg'
                          : '/assets/images/icons/arrow-down_dark.svg'
                      "
                      class="image"
                    />
                    <span class="fw-bold ticket-card__item__btn-text">
                      {{
                        ticket.expanded
                          ? ("Sport.HideTicket" | translate)
                          : ("Sport.ViewTicket" | translate)
                      }}
                    </span>
                  </div>
                </button>
              </div>
            </div>

            <div
              *ngIf="ticket.expanded"
              class="ticket-card__item__expandable-content disk-top-display"
            >
              <div class="ticket-card__item__expandable-content-item">
                <div class="ticket-card__item__expandable-content-item-first">
                  <div class="ticket-card__item__expandable-content-qr">
                    <div class="qrcodFrame">
                      <div
                        *ngIf="
                          ticket.id == '$$$$' ||
                          ticket.transferOrderStatus === 'UNDERTRANSFER'
                        "
                        class="container_"
                      >
                        <div class="tag">
                          {{
                            ticket.id === "$$$$" &&
                            ticket.transferOrderStatus !== "UNDERTRANSFER"
                              ? ("Sport.TicketNotActive" | translate)
                              : ("Sport.isBeningTransferred" | translate)
                          }}
                          <p
                            *ngIf="
                              ticket.id == '$$$$' &&
                              ticket.transferOrderStatus !== 'UNDERTRANSFER'
                            "
                            style="font-size: 8px"
                            class="mb-0"
                          >
                            {{
                              "Sport.Sport.BeforeXHours"
                                | translate : { value: hours }
                            }}
                          </p>
                        </div>
                        <img
                          [src]="[
                            'https://api.qrserver.com/v1/create-qr-code/?color=cecece&data=' +
                              ticket.id +
                              '&margin=30&height=100'
                          ]"
                          alt=""
                          class="image"
                        />
                      </div>
                      <img
                        *ngIf="
                          ticket.id != '$$$$' &&
                          ticket.transferOrderStatus !== 'UNDERTRANSFER'
                        "
                        src="{{
                          'https://api.qrserver.com/v1/create-qr-code/?data=' +
                            ticket.id +
                            '&margin=30&height=100'
                        }}"
                        alt=""
                        class="image"
                      />
                    </div>
                    <div
                      class="ticket-card__item__expandable-content-qr-number"
                    >
                      {{ "TicketNumber" | translate }}
                      {{ ticket.ticketNumber }}
                    </div>
                  </div>
                </div>

                <div>
                  <div class="ticket-card__item__expandable-content-item-label">
                    {{
                      translate.currentLang === "ar"
                        ? ticket.ticketNameAr
                        : ticket.ticketNameEn
                    }}
                  </div>
                  <div
                    class="ticket-card__item__expandable-content-item-content"
                  >
                    <span *ngIf="ticket.seat">
                      {{ "Sport.Section" | translate }}
                      {{ ticket.section }},
                      {{ "Sport.Row" | translate }}
                      {{ ticket.row }},
                      {{ "Sport.Seat" | translate }}
                      {{ ticket.seat }}
                    </span>
                  </div>
                </div>

                <div>
                  <div class="ticket-card__item__expandable-content-item-label">
                    {{ "Sport.Gate" | translate }}
                  </div>

                  <div
                    class="ticket-card__item__expandable-content-item-content"
                  >
                    {{ ticket?.gate || "___" }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mobile-card mobile-display">
              <div class="match-card">
                <img src="{{ ticket.teamHomeLogo }}" />

                <span class="black-box">
                  {{ ticket.matchDate | date }} |
                  {{ ticket.matchTime }}
                </span>
                <img src="{{ ticket.teamAwayLogo }}" />
              </div>
              <div class="mobile-card__details">
                <div class="mobile-card__details__ticket">
                  <div class="mobile-card__details__ticket-type">
                    {{
                      translate.currentLang === "ar"
                        ? ticket.ticketNameAr
                        : ticket.ticketNameEn
                    }}
                  </div>

                  <div class="mobile-card__details__ticket-place">
                    <span *ngIf="ticket.seat">
                      {{ "Sport.Section" | translate }}
                      {{ ticket.section }},
                      {{ "Sport.Row" | translate }}
                      {{ ticket.row }},
                      {{ "Sport.Seat" | translate }}
                      {{ ticket.seat }}
                    </span>
                  </div>
                </div>
                <div class="mobile-card__details__status">
                  <div class="mobile-card__details__status-data">
                    <div class="mobile-card__details__status-data-label">
                      <span
                        *ngIf="
                          ticket.transferOrderStatus !== 'TRANSFERRED' &&
                          ticket.transferOrderStatus !== 'UNDERTRANSFER'
                        "
                      >
                        <ng-container *ngIf="ticket.price !== 0">
                          <span
                            [innerHTML]="
                              ticket.price * 1.15
                                | number : '1.2-2'
                                | customCurrency
                                  : 'SAR'
                                  : 'symbol'
                                  : '#2f78ee'
                                  : 28
                            "
                          ></span>
                        </ng-container>

                        <ng-container *ngIf="ticket.price === 0">
                          {{ "free" | translate }}
                        </ng-container>
                      </span>
                      <span
                        *ngIf="ticket.transferOrderStatus === 'TRANSFERRED'"
                      >
                        {{ "Sport.TransferredToMe" | translate }}
                      </span>
                      <span
                        class="small-text"
                        *ngIf="ticket.transferOrderStatus === 'UNDERTRANSFER'"
                      >
                        {{ "Sport.TransferredTo" | translate }}
                      </span>
                    </div>
                    <div class="mobile-card__details__status-data-sub-content">
                      <span
                        *ngIf="
                          ticket.transferOrderStatus !== 'TRANSFERRED' &&
                          ticket.transferOrderStatus !== 'UNDERTRANSFER'
                        "
                      >
                        {{ ticket.price }} / {{ "Sport.Ticket" | translate }} +
                        {{ (ticket.price * 1.15 - ticket.price).toFixed(2) }}
                        {{ "Sport.tax" | translate }}
                      </span>
                      <span
                        *ngIf="ticket.transferOrderStatus === 'UNDERTRANSFER'"
                      >
                        <div style="margin-bottom: 5%">
                          {{
                            ticket.receiverFirstName +
                              " " +
                              ticket.receiverLastName
                          }}
                        </div>
                        <div>
                          <span *ngIf="translate.currentLang === 'en'">
                            {{ ticket.receiverMobile }}
                          </span>
                          <span *ngIf="translate.currentLang === 'ar'">
                            {{
                              helpers.returnMobileArabic(ticket.receiverMobile)
                            }}
                          </span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="mobile-card__details__status-btns">
                  <button
                    *ngIf="ticket.transferOrderStatus !== 'UNDERTRANSFER'"
                    app-click-stop-propagation
                    class="mobile-card__details__status-btns__btn basic-btn"
                    (click)="
                      ticket.id === '$$$$'
                        ? transferDisabledTicket(ticket.ticketNumber)
                        : transferTicket(ticket.id)
                    "
                    [disabled]="ticket.ticketSubKind === 'FULL_SEASON'"
                  >
                    <div style="text-align: -webkit-center; display: flex">
                      <img
                        src="/assets/images/icons/share.svg"
                        class="image"
                        [style.opacity]="
                          ticket.ticketSubKind === 'FULL_SEASON' ? '0.5' : ''
                        "
                      />
                      <span> {{ "Sport.Transfer" | translate }}</span>
                    </div>
                  </button>

                  <button
                    app-click-stop-propagation
                    *ngIf="ticket.transferOrderStatus === 'UNDERTRANSFER'"
                    class="mobile-card__details__status-btns__btn basic-btn"
                    (click)="cancelTicket([ticket.transferOrderId])"
                  >
                    <div>
                      <span> {{ "Sport.CancelTransfer" | translate }}</span>
                    </div>
                  </button>

                  <button
                    class="mobile-card__details__status-btns__btn basic-btn"
                    (click)="toggleExpand(ticket)"
                  >
                    <div style="text-align: -webkit-center; display: flex">
                      <img
                        [src]="
                          ticket.expanded
                            ? '/assets/images/icons/arrow-up_dark.svg'
                            : '/assets/images/icons/arrow-down_dark.svg'
                        "
                        class="image"
                      />
                      <span>
                        {{
                          ticket.expanded
                            ? ("Sport.HideTicket" | translate)
                            : ("Sport.ViewTicket" | translate)
                        }}
                      </span>
                    </div>
                  </button>
                </div>
              </div>

              <div
                *ngIf="ticket.expanded"
                class="ticket-card__item__expandable-content"
              >
                <div class="ticket-card__item__expandable-content-item">
                  <div class="ticket-card__item__expandable-content-item-first">
                    <div class="ticket-card__item__expandable-content-qr">
                      <div class="qrcodFrame">
                        <div
                          *ngIf="
                            (myTicketsStatus === ticket.id) == '$$$$' ||
                            ticket.transferOrderStatus === 'UNDERTRANSFER'
                          "
                          class="container_"
                        >
                          <div class="tag">
                            {{
                              ticket.id === "$$$$" &&
                              ticket.transferOrderStatus !== "UNDERTRANSFER"
                                ? ("Sport.TicketNotActive" | translate)
                                : ("Sport.isBeningTransferred" | translate)
                            }}

                            <p
                              *ngIf="
                                ticket.id == '$$$$' &&
                                ticket.transferOrderStatus !== 'UNDERTRANSFER'
                              "
                              style="font-size: 8px"
                              class="mb-0"
                            >
                              {{
                                "Sport.BeforeXHours"
                                  | translate : { value: hours }
                              }}
                            </p>
                          </div>
                          <img
                            [src]="[
                              'https://api.qrserver.com/v1/create-qr-code/?color=cecece&data=' +
                                ticket.id +
                                '&margin=30&height=100'
                            ]"
                            alt=""
                            class="image"
                          />
                        </div>
                        <img
                          *ngIf="
                            ticket.id != '$$$$' &&
                            ticket.transferOrderStatus !== 'UNDERTRANSFER'
                          "
                          src="{{
                            'https://api.qrserver.com/v1/create-qr-code/?data=' +
                              ticket.id +
                              '&margin=30&height=100'
                          }}"
                          alt=""
                          class="image"
                        />
                      </div>

                      <div
                        class="ticket-card__item__expandable-content-qr-number"
                      >
                        {{ "TicketNumber" | translate }}
                        {{ ticket.ticketNumber }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="ticket-card__item__expandable-content-item-second"
                  >
                    <div
                      class="ticket-card__item__expandable-content-item-second-price"
                    >
                      <div
                        class="ticket-card__item__expandable-content-item-label"
                      >
                        {{ "Sport.Gate" | translate }}
                      </div>

                      <div
                        class="ticket-card__item__expandable-content-item-content"
                      >
                        {{ ticket.gate || "___" }}
                      </div>
                    </div>

                    <div
                      class="ticket-card__item__expandable-content-item-second-name"
                    >
                      <div
                        class="ticket-card__item__expandable-content-item-label"
                      >
                        {{
                          translate.currentLang === "ar"
                            ? ticket.ticketNameAr
                            : ticket.ticketNameEn
                        }}
                      </div>

                      <div
                        class="ticket-card__item__expandable-content-item-content"
                      >
                        <span *ngIf="ticket.seat">
                          {{ "Sport.Section" | translate }}
                          {{ ticket.section }},
                          {{ "Sport.Row" | translate }}
                          {{ ticket.row }},
                          {{ "Sport.Seat" | translate }}
                          {{ ticket.seat }}
                        </span>
                        <!-- <span *ngIf="!ticket.seat">
                          {{ "Tickets.ChooseYourAppropriateSeat" | translate }}
                        </span> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-pagination
        *ngIf="ticketsMeta"
        [meta]="ticketsMeta"
        (goPage)="goToPage($event)"
        (goNext)="onNext()"
        (goPrev)="onPrev()"
      >
      </app-pagination>
    </div>
  </div>
</div>
<ng-template #noData>
  <app-nodata
    title="{{ 'No Tickets Yet' | translate }}"
    [img]="'assets/images/tickets/no-ticket.png'"
    link=""
  ></app-nodata>
</ng-template>
<ng-template #loader>
  <app-loading></app-loading>
</ng-template>
